module.exports = ".editor {\n  padding: 1em; \n}"